import { render, staticRenderFns } from "./PufaVideo.vue?vue&type=template&id=9557303e&scoped=true"
import script from "./PufaVideo.vue?vue&type=script&lang=js"
export * from "./PufaVideo.vue?vue&type=script&lang=js"
import style0 from "./PufaVideo.vue?vue&type=style&index=0&id=9557303e&prod&lang=css"
import style1 from "./PufaVideo.vue?vue&type=style&index=1&id=9557303e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9557303e",
  null
  
)

export default component.exports